export default __webpack_public_path__ + "static/media/wifi-3.9de4c68d.png";